import { Poline, positionFunctions } from "poline";

const baseHue = Math.random() * 360;
const spread = 100 + Math.random() * 40;

export const poline = new Poline({
  anchorColors: [
    [baseHue % 360, 0.7, 0.7],
    [(baseHue + spread) % 360, 0.7, 0.4],
    [(baseHue + spread * 2) % 360, 0.7, 0.75],
  ],
  numPoints: 2,
  positionFunctionX: positionFunctions.quadraticPosition,
  positionFunctionY: positionFunctions.sinusoidalPosition,
  positionFunctionZ: positionFunctions.linearPosition,
});
